
export class DuplicateDanceEventRequestDto {
  name: string;
  startDate: Date;
  duration: number;
  duplicateTickets: boolean;
}
